import {useTranslation} from "react-i18next";
import React, {Fragment} from "react";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import {TableLoadingRow} from "../../ui/table/TableLoadingRow";
import {TableEmptyRow} from "../../ui/table/TableEmptyRow";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import {makeStyles} from "@material-ui/core/styles";
import {Typography} from "@material-ui/core";
import {Organization} from "../../../models/organization";

export const useStyles = makeStyles(theme => ({
    root: {
        height: 'auto',
        flexGrow: 1,
        maxWidth: 700,
    },
    search: {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '40%'
        }
    },
    actionColumn: {
        maxWidth: 100,
        width: 100
    },
    spinner: {
        position: 'absolute',
        left: '50%'
    }
}));

export const OrganizationDataRow = ({
                                        organization,
                                        actions
                                    }: { organization: Organization, actions: (organization: Organization) => any }) =>
    <TableRow>
        <TableCell component="th" scope="row">
            <Typography variant="body1">{organization.id}</Typography>
        </TableCell>
        <TableCell>
            <Typography variant="body1">{organization.name}</Typography>
        </TableCell>
        <TableCell align="center">
            {actions(organization)}
        </TableCell>
    </TableRow>


export const OrganizationsTable = ({loading, data: organizations, isEmptyMsgKey, ...props}: any) => {
    const {t} = useTranslation();
    return (
        <Fragment>
            <TableHead>
                <TableRow>
                    <TableCell>
                        <label>
                            {t('Organizations.ID')}
                        </label>
                    </TableCell>
                    <TableCell>
                        <label>
                            {t('Organizations.Name')}
                        </label>
                    </TableCell>
                    <TableCell style={{width: "50px"}} align="center">
                        <label>
                            {t(`Machine.Actions.Title`)}
                        </label>
                    </TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {
                    loading ?
                        <TableLoadingRow/> :
                        organizations.length === 0 ?
                            <TableEmptyRow messageKey={isEmptyMsgKey ? isEmptyMsgKey : '_Common.Messages.NoRecord'}/> :
                            organizations.map((o: any) => <OrganizationDataRow
                                key={o.id}
                                organization={o}
                                {...props}
                            />)
                }
            </TableBody>
        </Fragment>
    );
}
